<template>
  <div>
    <navigation></navigation>

    <router-view></router-view>

    <footer class="footer">
      <div class="container text-center">
        <img src="/img/footer.png" style="height: 30px">
      </div>
    </footer>
  </div>
</template>

<script>
import store from '@/store'
import Echo from 'laravel-echo'
import Navigation from '@/components/Layout/Navigation'

export default {
  components: {Navigation},

  data() {
    return {
      shared: store,
      echo: new Echo({
        broadcaster: 'pusher',
        key: 'ccff5b3821a92cedae49',
        cluster: 'eu',
        encrypted: true,
        auth: {
          headers: {
            'Authorization': 'Bearer ' + store.token
          }
        }
      })
    }
  },

  mounted() {
    this.echo.join('general')
        .here(users => {
          this.shared.online = users
        })
        .joining(user => {
          this.shared.online = this.shared.online.concat([user])
        })
        .leaving(user => {
          this.shared.online.splice(this.shared.online.findIndex(existing => existing.id === user.id), 1)
        })
  },

  destroyed() {
    this.echo.leave('general')
  }
}
</script>
